export default {
  scenes: {
    lifeWithoutHim: {
      beats: {
        timeMovesForward: {
          events: [
            {
              type: 'showLocation',
              locationId: 'newCafe'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'Months pass. Reina rebuilds herself. She no longer checks her phone for his name. The pain is gone—or at least, small enough to ignore.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'What has Reina been focusing on?',
              choices: [
                {
                  text: 'Her Career',
                  next: {
                    scene: 'lifeWithoutHim',
                    beat: 'careerFocus'
                  }
                },
                {
                  text: 'Her Personal Life',
                  next: {
                    scene: 'lifeWithoutHim',
                    beat: 'personalLifeFocus'
                  }
                }
              ]
            }
          ]
        },
        careerFocus: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'I built this on my own.'
            },
            {
              type: 'showNarration',
              text: 'She\'s thriving, fully immersed in her work, proving to herself that she never needed him to succeed.'
            },
            {
              type: 'showEffect',
              effect: 'motionLines',
              rotation: 0,
              duration: 1,
              waitUntilFinish: true
            },
            {
              type: 'hideEffect',
              effect: 'motionLines'
            }
          ],
          next: {
            scene: 'lifeWithoutHim',
            beat: 'unexpectedTrip'
          }
        },
        personalLifeFocus: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'I forgot how much I love just… being happy.'
            },
            {
              type: 'showNarration',
              text: 'She spends her time with friends, exploring new places, falling in love with life again.'
            },
            {
              type: 'showEffect',
              effect: 'fallingLeaves',
              color: '#FFA500',
              count: 20,
              duration: 2,
              waitUntilFinish: true
            },
            {
              type: 'hideEffect',
              effect: 'fallingLeaves'
            }
          ],
          next: {
            scene: 'lifeWithoutHim',
            beat: 'unexpectedTrip'
          }
        },
        unexpectedTrip: {
          events: [
            {
              type: 'showLocation',
              locationId: 'newCafe'
            },
            {
              type: 'showNarration',
              text: 'One day, Reina takes a trip—to a different city, a different country. A new beginning. She isn\'t looking for anything, just enjoying her life. But then…'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'I feel like I\'ve been here before.'
            }
          ],
          next: {
            scene: 'momentChangesEverything',
            beat: 'familiarVoice'
          }
        }
      }
    },
    momentChangesEverything: {
      beats: {
        familiarVoice: {
          events: [
            {
              type: 'showLocation',
              locationId: 'newCafe'
            },
            {
              type: 'showNarration',
              text: 'She\'s at a café, flipping through her book, when she hears it. A voice she knows too well. One she hasn\'t heard in so long.'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'What does Reina do?',
              choices: [
                {
                  text: 'Look Up Immediately',
                  next: {
                    scene: 'momentChangesEverything',
                    beat: 'lookUpImmediately'
                  }
                },
                {
                  text: 'Ignore It, Just for a Moment',
                  next: {
                    scene: 'momentChangesEverything',
                    beat: 'ignoreForMoment'
                  }
                }
              ]
            }
          ]
        },
        lookUpImmediately: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'surprised',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'surprised',
              text: 'No way…'
            },
            {
              type: 'showNarration',
              text: 'She turns, and there he is—Eric, standing only a few feet away, completely unaware of her presence.'
            },
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 5,
              duration: 0.5,
              waitUntilFinish: true
            }
          ],
          next: {
            scene: 'momentChangesEverything',
            beat: 'secondChance'
          }
        },
        ignoreForMoment: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'Maybe I\'m imagining it.'
            },
            {
              type: 'showNarration',
              text: 'But she knows she isn\'t. She lets the moment hang in the air before finally turning to look.'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.5,
              duration: 1,
              waitUntilFinish: true
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          next: {
            scene: 'momentChangesEverything',
            beat: 'secondChance'
          }
        },
        secondChance: {
          events: [
            {
              type: 'showNarration',
              text: 'For a moment, neither of them speaks. The world shrinks. It\'s just them, standing there, trying to figure out what this means.'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'surprised',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'surprised',
              text: 'Reina…?'
            }
          ],
          next: {
            scene: 'whatNow',
            beat: 'firstWordsInForever'
          }
        }
      }
    },
    whatNow: {
      beats: {
        firstWordsInForever: {
          events: [
            {
              type: 'showLocation',
              locationId: 'newCafe'
            },
            {
              type: 'showNarration',
              text: 'They sit at a table—different country, different city, same people. Reina studies him, wondering how much has changed.'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'How does Reina break the silence?',
              choices: [
                {
                  text: 'Keep It Light',
                  next: {
                    scene: 'whatNow',
                    beat: 'keepItLight'
                  }
                },
                {
                  text: 'Be Honest',
                  next: {
                    scene: 'whatNow',
                    beat: 'beHonest'
                  }
                }
              ]
            }
          ]
        },
        keepItLight: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'What, no coffee in your city? Had to follow me here?'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'happy',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'You always did think the universe revolved around you.'
            },
            {
              type: 'showNarration',
              text: 'The tension eases, just a little.'
            }
          ],
          next: {
            scene: 'whatNow',
            beat: 'questionThatMatters'
          }
        },
        beHonest: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'sad',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'I didn\'t think I\'d ever see you again.'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'sad',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'sad',
              text: 'Me neither.'
            },
            {
              type: 'showNarration',
              text: 'The weight of it all settles between them.'
            }
          ],
          next: {
            scene: 'whatNow',
            beat: 'questionThatMatters'
          }
        },
        questionThatMatters: {
          events: [
            {
              type: 'showNarration',
              text: 'Eventually, the words come—the apology, the regret, the things left unsaid. But at the heart of it all is one question: does it matter anymore?'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'thinking',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'thinking',
              text: 'Do you ever wonder… what would\'ve happened if I\'d stayed?'
            }
          ],
          next: {
            scene: 'finalChoice',
            beat: 'fateOrClosure'
          }
        }
      }
    },
    finalChoice: {
      beats: {
        fateOrClosure: {
          events: [
            {
              type: 'showLocation',
              locationId: 'newCafe'
            },
            {
              type: 'showNarration',
              text: 'Reina knows this is it. The universe brought them here, but what she does next? That\'s up to her.'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'thinking',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'What does Reina choose?',
              choices: [
                {
                  text: 'Give Fate a Chance',
                  next: {
                    scene: 'finalChoice',
                    beat: 'giveFateAChance'
                  }
                },
                {
                  text: 'Smile and Walk Away',
                  next: {
                    scene: 'finalChoice',
                    beat: 'smileAndWalkAway'
                  }
                }
              ]
            }
          ]
        },
        giveFateAChance: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'Maybe we were always supposed to meet again.'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'happy',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'And maybe this time, we\'ll get it right.'
            },
            {
              type: 'showNarration',
              text: 'They stay, talking until the café closes, until it feels like no time has passed at all.'
            },
            {
              type: 'showEffect',
              effect: 'fallingLeaves',
              color: '#FFC0CB',
              count: 30,
              duration: 3,
              waitUntilFinish: true
            },
            {
              type: 'hideEffect',
              effect: 'fallingLeaves'
            },
            {
              type: 'showNarration',
              text: 'THE END.'
            }
          ],
          goToGameOver: true
        },
        smileAndWalkAway: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'I don\'t think we were meant to last, Eric. But I\'m glad we met.'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'sad',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'sad',
              text: 'Me too.'
            },
            {
              type: 'showNarration',
              text: 'She walks away, feeling nothing but peace.'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.7,
              duration: 2,
              waitUntilFinish: true
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            },
            {
              type: 'showNarration',
              text: 'THE END.'
            }
          ],
          goToGameOver: true
        }
      }
    }
  }
}
